import classes from './ServicesTab.module.scss';
import i18n from '../../../../../utils/i18n';
import CheckboxService from '../../../../components/CheckboxService';
import { FormControlLabel } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import ACTIONS from '../../../../../redux/action';
import { providerServicesText } from '../../../../data/providerText';
import { useEffect, useContext } from 'react';
import InsuranceInfo from './components/InsuranceInfo';
import InputContext from '../../../../../context/inputContext';

const ServicesTab = ({ providerData }) => {
	const dispatch = useDispatch();

	const [providerServices] = useSelector((state) => [state.provider_services]);
	const { isChanged, setIsChanged } = useContext(InputContext);

	useEffect(() => {
		console.log('PROVIDER SERVICES', providerServices);
		console.log('PROVIDER DATA', providerData);
	}, [providerServices, providerData]);

	const handleCheck = (event) => {
		dispatch(
			ACTIONS.addCompanyInfo({
				id: event.target.id,
				data: event.target.checked,
				stateObject: 'provider_services',
			})
		);
		dispatch(
			ACTIONS.updateNestedObject({
				id: 'iscompleted',
				data: true,
				stateObject: 'provider_onboarding',
				stateObjectID: `services_flow`,
			})
		);
	};

	const updateProviderInfo = (id, data, stateObject) => {
		dispatch(
			ACTIONS.addProviderInfo({
				id,
				data,
				stateObject,
			})
		);
	};

	return (
		<>
			<div className={classes.paragraph}>
				<div className={classes.leftColumn}>
					<div className={classes.profileTitle}>
						{i18n.t('provider.servicestitle')}
					</div>
					<div className={classes.profileSubTitle}>
						{i18n.t('provider.servicessubtitle')}
					</div>
				</div>
				<div className={classes.rightColumn}>
					{providerServicesText().map((service) => (
						<FormControlLabel
							key={service.id}
							control={
								<div style={{ width: '100%' }}>
									<CheckboxService
										id={service.id}
										checked={providerServices[service.id]}
										title={service.label}
										subTitle={service.subLabel}
										isSelected={providerServices[service.id]}
										onSelect={(event) => {
											handleCheck(event);
											setIsChanged(true);
										}}
									/>
								</div>
							}
							className={classes.formControlLabel}
						/>
					))}
				</div>
			</div>

			<div className={classes.paragraph}>
				<div className={classes.leftColumn}>
					<div className={classes.profileTitle}>
						{i18n.t('general.liabilityinsurance')}
					</div>
					<div className={classes.profileSubTitle}>
						{i18n.t('provider.liabilityinsurancesub')}
					</div>
				</div>
				<div className={classes.rightColumn}>
					{/* <div className={classes.insuranceOptions}>
					<SelectorOption
						label={i18n.t('provider.liabilityinsuranceyes')}
						subLabel=''
						icon={hasInsurance === true ? GeneralBlueTick : InsuranceShieldOn}
						isSelected={hasInsurance === true}
						onClick={() => handleSelectInsurance(true)}
						borderRadius='8px 0 0 8px'
						borderSides={{ top: true, right: true, bottom: true, left: true }}
					/>
					<SelectorOption
						label={i18n.t('provider.liabilityinsuranceno')}
						subLabel=''
						icon={
							hasInsurance === false ? GeneralBlueTick : InsuranceShieldOff
						}
						isSelected={hasInsurance === false}
						onClick={() => handleSelectInsurance(false)}
						borderRadius='0 8px 8px 0'
						borderSides={{
							top: true,
							right: true,
							bottom: true,
							left: false,
						}}
					/>
				</div> */}

					{/* {Object.keys(providerData.provider_liability_insurance)
						.filter((key) => !key.includes('Expiration') && !key.includes('Value'))
						.every((key) => providerData.provider_liability_insurance[key] === false) && ( */}
					{/* <MarketingBanner
						imgSrc={InsuranceLady}
						title={i18n.t('provider.bannerinsurancetitle')}
						subtitle={i18n.t('provider.bannerinsurancesubtitle')}
						imgWidth='95px'
						imgMarginLeft='0'
						buttonLabel={i18n.t('provider.bannerinsurancebutton')}
						onButtonClick={() => console.log('Clicked!')}
					/> */}
					{/* )} */}

					{/* <div className={classes.buttonInsurance}>
					<CustomButton
						buttonName={i18n.t('provider.bannerinsuranceattachement')}
						iconSrc={IconInsuranceAttachement}
						buttonColor='#e0e0ff'
						hoverColor='#e0e0ff'
						titleColor='#1c32f3'
						titleHoverColor='#1c32f3'
						width='270px'
						height='44px'
						padding='12px'
						onClick={() => setOpenInsuranceDialog(true)}
					/>
					<InsuranceAttachement
						openInsuranceAttachement={openInsuranceDialog}
						setOpenInsuranceAttachement={setOpenInsuranceDialog}
					/>
				</div> */}

					{providerServices.accounting && (
						<div className={classes.buttonInsurance}>
							{Object.keys(providerData.provider_liability_insurance)
								.filter((key) => key === 'accounting')
								.map((key) => (
									<InsuranceInfo
										key={key}
										service={i18n.t(`general.${key}`)}
										isSelected={providerData.provider_liability_insurance[key]}
										insuredAmount={
											providerData.provider_liability_insurance[
												`${key}Value`
											] || '-'
										}
										expiryDate={
											providerData.provider_liability_insurance[
												`${key}Expiration`
											] || '--.--.----'
										}
										onSelect={() => {
											updateProviderInfo(
												key,
												!providerData.provider_liability_insurance[key],
												'provider_liability_insurance'
											);
											setIsChanged(true);
										}}
										onSelectValue={(newValue) => {
											updateProviderInfo(
												`${key}Value`,
												newValue,
												'provider_liability_insurance'
											);
											setIsChanged(true);
										}}
										onSelectExpiration={(newDate) => {
											updateProviderInfo(
												`${key}Expiration`,
												newDate,
												'provider_liability_insurance'
											);
											setIsChanged(true);
										}}
									/>
								))}
						</div>
					)}

					{providerServices.payroll && (
						<div className={classes.buttonInsurance}>
							{Object.keys(providerData.provider_liability_insurance)
								.filter(
									(key) => key === 'payroll' || key === 'simplifiedpayroll'
								)
								.map((key) => (
									<InsuranceInfo
										key={key}
										service={i18n.t(`general.${key}`)}
										isSelected={providerData.provider_liability_insurance[key]}
										insuredAmount={
											providerData.provider_liability_insurance[
												`${key}Value`
											] || '-'
										}
										expiryDate={
											providerData.provider_liability_insurance[
												`${key}Expiration`
											] || '--.--.----'
										}
										onSelect={() => {
											updateProviderInfo(
												key,
												!providerData.provider_liability_insurance[key],
												'provider_liability_insurance'
											);
											setIsChanged(true);
										}}
										onSelectValue={(newValue) => {
											updateProviderInfo(
												`${key}Value`,
												newValue,
												'provider_liability_insurance'
											);
											setIsChanged(true);
										}}
										onSelectExpiration={(newDate) => {
											updateProviderInfo(
												`${key}Expiration`,
												newDate,
												'provider_liability_insurance'
											);
											setIsChanged(true);
										}}
									/>
								))}
						</div>
					)}

					{providerServices.taxconsulting && (
						<div className={classes.buttonInsurance}>
							{Object.keys(providerData.provider_liability_insurance)
								.filter((key) => key === 'taxconsulting')
								.map((key) => (
									<InsuranceInfo
										key={key}
										service={i18n.t(`general.${key}`)}
										isSelected={providerData.provider_liability_insurance[key]}
										insuredAmount={
											providerData.provider_liability_insurance[
												`${key}Value`
											] || '-'
										}
										expiryDate={
											providerData.provider_liability_insurance[
												`${key}Expiration`
											] || '--.--.----'
										}
										onSelect={() => {
											updateProviderInfo(
												key,
												!providerData.provider_liability_insurance[key],
												'provider_liability_insurance'
											);
											setIsChanged(true);
										}}
										onSelectValue={(newValue) => {
											updateProviderInfo(
												`${key}Value`,
												newValue,
												'provider_liability_insurance'
											);
											setIsChanged(true);
										}}
										onSelectExpiration={(newDate) => {
											updateProviderInfo(
												`${key}Expiration`,
												newDate,
												'provider_liability_insurance'
											);
											setIsChanged(true);
										}}
									/>
								))}
						</div>
					)}

					{providerServices.legalentityfounding && (
						<div className={classes.buttonInsurance}>
							{Object.keys(providerData.provider_liability_insurance)
								.filter((key) => key === 'legalentityfounding')
								.map((key) => (
									<InsuranceInfo
										key={key}
										service={i18n.t(`general.${key}`)}
										isSelected={providerData.provider_liability_insurance[key]}
										insuredAmount={
											providerData.provider_liability_insurance[
												`${key}Value`
											] || '-'
										}
										expiryDate={
											providerData.provider_liability_insurance[
												`${key}Expiration`
											] || '--.--.----'
										}
										onSelect={() => {
											updateProviderInfo(
												key,
												!providerData.provider_liability_insurance[key],
												'provider_liability_insurance'
											);
											setIsChanged(true);
										}}
										onSelectValue={(newValue) => {
											updateProviderInfo(
												`${key}Value`,
												newValue,
												'provider_liability_insurance'
											);
											setIsChanged(true);
										}}
										onSelectExpiration={(newDate) => {
											updateProviderInfo(
												`${key}Expiration`,
												newDate,
												'provider_liability_insurance'
											);
											setIsChanged(true);
										}}
									/>
								))}
						</div>
					)}
					{providerServices.audit && (
						<div className={classes.buttonInsurance}>
							{Object.keys(providerData.provider_liability_insurance)
								.filter((key) => key === 'audit')
								.map((key) => (
									<InsuranceInfo
										key={key}
										service={i18n.t(`general.${key}`)}
										isSelected={providerData.provider_liability_insurance[key]}
										insuredAmount={
											providerData.provider_liability_insurance[
												`${key}Value`
											] || '-'
										}
										expiryDate={
											providerData.provider_liability_insurance[
												`${key}Expiration`
											] || '--.--.----'
										}
										onSelect={() => {
											updateProviderInfo(
												key,
												!providerData.provider_liability_insurance[key],
												'provider_liability_insurance'
											);
											setIsChanged(true);
										}}
										onSelectValue={(newValue) => {
											updateProviderInfo(
												`${key}Value`,
												newValue,
												'provider_liability_insurance'
											);
											setIsChanged(true);
										}}
										onSelectExpiration={(newDate) => {
											updateProviderInfo(
												`${key}Expiration`,
												newDate,
												'provider_liability_insurance'
											);
											setIsChanged(true);
										}}
									/>
								))}
						</div>
					)}
					{providerServices.liquidation && (
						<div className={classes.buttonInsurance}>
							{Object.keys(providerData.provider_liability_insurance)
								.filter((key) => key === 'liquidation')
								.map((key) => (
									<InsuranceInfo
										key={key}
										service={i18n.t(`general.${key}`)}
										isSelected={providerData.provider_liability_insurance[key]}
										insuredAmount={
											providerData.provider_liability_insurance[
												`${key}Value`
											] || '-'
										}
										expiryDate={
											providerData.provider_liability_insurance[
												`${key}Expiration`
											] || '--.--.----'
										}
										onSelect={() => {
											updateProviderInfo(
												key,
												!providerData.provider_liability_insurance[key],
												'provider_liability_insurance'
											);
											setIsChanged(true);
										}}
										onSelectValue={(newValue) => {
											updateProviderInfo(
												`${key}Value`,
												newValue,
												'provider_liability_insurance'
											);
											setIsChanged(true);
										}}
										onSelectExpiration={(newDate) => {
											updateProviderInfo(
												`${key}Expiration`,
												newDate,
												'provider_liability_insurance'
											);
											setIsChanged(true);
										}}
									/>
								))}
						</div>
					)}
				</div>
			</div>
		</>
	);
};

export default ServicesTab;
